import { FileTypeInfo, BulkUploadFileType } from "@/types/bulk-upload";

export const SUPPORTED_EXTENSIONS: Record<string, BulkUploadFileType> = {
  pdf: "pdf",
  doc: "doc",
  docx: "docx",
  txt: "txt",
  csv: "csv",
  jpg: "image",
  jpeg: "image",
  png: "image",
  webp: "image",
};

export const SUPPORTED_MIME_TYPES: Record<string, BulkUploadFileType> = {
  "application/pdf": "pdf",
  "application/msword": "doc",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
  "text/plain": "txt",
  "text/csv": "csv",
  "image/jpeg": "image",
  "image/png": "image",
  "image/webp": "image",
};

export const ACCEPTED_EXTENSIONS = ".pdf,.doc,.docx,.txt,.csv,.jpg,.jpeg,.png,.webp";
export const ACCEPTED_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "text/plain",
  "text/csv",
  "image/jpeg",
  "image/png",
  "image/webp",
].join(",");

export const getFileTypeInfo = (file: File): FileTypeInfo | null => {
  // Check MIME type first
  const mimeType = SUPPORTED_MIME_TYPES[file.type];
  if (mimeType) {
    return {
      type: mimeType,
      action: mimeType === "pdf" ? "upload-pdf" : mimeType === "image" ? "upload-image" : "extract-document",
    };
  }

  // Fall back to extension
  const extension = file.name.split(".").pop()?.toLowerCase();
  if (extension && SUPPORTED_EXTENSIONS[extension]) {
    const fileType = SUPPORTED_EXTENSIONS[extension];
    return {
      type: fileType,
      action: fileType === "pdf" ? "upload-pdf" : fileType === "image" ? "upload-image" : "extract-document",
    };
  }

  return null;
};
